import styled from 'styled-components';
export const CalendarWrapDiv = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  // position: relative;
  width: 57%;
  width: 38rem;
`;

export const CalendarMainComponentWrapper = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  // border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  flex-direction: column;
  display:flex;
  `,
);
export const MonthWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const MonthNamePara = styled.p(
  props => `
  display: flex;
  flex-direction: row;
  font-family:${props.theme.font.fontFamily};
  font-size:${props.theme.font.large};
  padding-bottom:${props.theme.spacing.large};
  padding-top:${props.theme.spacing.large};
  padding-left:${props.theme.spacing.xxlarge};
  padding-right:${props.theme.spacing.xxlarge};
  font-weight:bold;
  `,
);
export const MonthChangeArrowDiv = styled.div(
  props => `
  // display: flex;
  `,
);
export const DayAndDateWrapperDiv = styled.div(
  props => `
  width:100%;
  display: flex;
  flex-direction: column;
  padding-top:${props.theme.spacing.xsmall};
  padding-left:${props.theme.spacing.xxlarge};
  padding-right:${props.theme.spacing.xxlarge};
  padding-bottom:${props.theme.spacing.small};
  // border-right: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  `,
);
export const DayWrapDiv = styled.ul(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
      li{
        width:4.5rem;
        height:3.5rem;
        justify-content: center;
        display: flex;
        flex-wrap:wrap;
        flex-direction: column;
        align-items: center;
        font-size:${props.theme.font.custom(14)};
        color:${props.theme.colors.downriver.medium};
      }
  `,
);
export const DateWrapDiv = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    display: flex;
    flex-direction: column;
    width: 4.5rem;
    height: 4.5rem;
    justify-content: center;
    span {
      width: 100%;
      display: flex;
      flex-direction: column;
      font-size: ${props => props.theme.font.large};
      color: black;
      font-family: ${props => props.theme.font.fontFamily};
      align-items: center;
      &:hover {
        width: 4.5rem;
        height: 4.5rem;
        background-color: ${props => props.theme.colors.goBrandBlue.light};
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      &.partial {
        width: 4.5rem;
        height: 4.5rem;
        background-color: ${props => props.theme.colors.goBrandBlue.light};
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      &.leftactive {
        font-weight: bold;
        width: 4.5rem;
        height: 4.5rem;
        background-color: ${props => props.theme.colors.goBrandBlue.base};
        display: flex;
        flex-direction: column;
        color: ${props => props.theme.colors.goWhite.base};
        justify-content: center;
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
      }
      &.rightactive {
        font-weight: bold;
        width: 4.5rem;
        height: 4.5rem;
        background-color: ${props => props.theme.colors.goBrandBlue.base};
        display: flex;
        flex-direction: column;
        color: ${props => props.theme.colors.goWhite.base};
        justify-content: center;
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
      }
    }
  }
`;
/**** uncomment for holiday selected dates on the calender ****/
export const DateWrapLi = styled.li``;
export const SecondMonthWrapper = styled.div(
  props => `
  width:50%;
  display: flex;
  flex-direction: column;
  `,
);
export const ActiveBackWrapper = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  border-radius:${props.theme.misc.bordersadius.small};
  `,
);
export const OuterMonthWrapDiv = styled.div(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
  align-items: center;
  width:100%;
  justify-content: space-around;
  position:relative;
  `,
);
export const CalendarMainWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
  width:100%;
  `,
);
export const NoofDaysStayDiv = styled.div(
  props => `
  display: flex;
  flex-wrap:wrap;
  background-color:${props.theme.colors.goTeal.medium};
  color:${props.theme.colors.goWhite.base};
  padding-top:${props.theme.spacing.small};
  padding-Bottom:${props.theme.spacing.small};
  padding-right:${props.theme.spacing.base};
  padding-left:${props.theme.spacing.base};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;
  border-radius:${props.theme.misc.borderRadius.custom(30)};
  `,
);
export const SliderArrow = styled.div(
  props => `
    width: 3rem;
    height: 3rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    // position: absolute;
    // transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    color: ${props.theme.colors.goBrandBlue.base};
  `,
);
export const MonthChangeLeftArrowDiv = styled.div(
  props => `
    position: absolute;
    left:3rem;
  `,
);
export const MonthChangeRightArrowDiv = styled.div(
  props => `
    position: absolute;
    right:4rem;
  `,
);
export const InnerMonthWrapDiv = styled.div(
  props => `
  display:flex;
  align-items:center;
  `,
);
